<template>
  <div
    v-if="recommendedProductsOrdered && recommendedProductsOrdered.length"
  >
    <ProductSliderContainer
      ref="cartRecommendationsProductsNode"
      :products="recommendedProductsOrdered"
      :size="size"
      :is-full-width="true"
      :product-box-type-tag="EVENT_SOURCE.CART_RECOMMENDATION"
      :has-arrows="hasArrows"
      prev-arrow-class="-left-3.5"
      next-arrow-class="-right-3.5"
      @product-clicked="(product) => parentClicked(product)"
    />
  </div>
</template>

<script lang="ts">

import { useIntersectionObserver } from '@vueuse/core';

import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import { PRODUCT_CARD_SIZE } from '~~/constants/productCardSize';
import type { ProductCardSize } from '~~/constants/productCardSize';
import { orderProductsByOnSale } from '~~/helpers/product/orderProductsByOnSale';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export default defineComponent({
  name: 'CartRecommendations',

  props: {
    recommendedProducts: {
      type: Array as PropType<ProductVariantExtended[]>,
      required: true,
    },
    sourceSku: {
      type: String,
      required: true,
    },
    size: {
      type: String as PropType<ProductCardSize>,
      default: PRODUCT_CARD_SIZE.MINI,
      validator: (value: ProductCardSize) => Object.values(PRODUCT_CARD_SIZE).includes(value),
    },
    hasArrows: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const cartRecommendationsProductsNode = ref<HTMLElement | null>(null);

    const {
      onIntersectCartRecommendationsOnce,
      onClickParentProduct,
    } = useProductRecommendationEvents({
      suggestedCartRecommendations: props.recommendedProducts,
      sourceProductSku: props.sourceSku,
    });

    useIntersectionObserver(cartRecommendationsProductsNode, onIntersectCartRecommendationsOnce);

    const parentClicked = (parentSku: string) => {

      onClickParentProduct(parentSku);
    
    };

    const recommendedProductsOrdered = computed(() => {

      return orderProductsByOnSale(props.recommendedProducts);
    
    });

    return {
      parentClicked,
      cartRecommendationsProductsNode,
      EVENT_SOURCE,
      recommendedProductsOrdered,
    };
  
  },
});

</script>
